import React from "react";

type Props = React.HTMLProps<any> & {
  tag: string;
};
export const HtmlLike = ({ children, tag, ...props }: Props) => {
  const El = tag as unknown as React.ComponentType<React.HTMLProps<any>>;

  return typeof children === "string" ? (
    <El dangerouslySetInnerHTML={{ __html: children }} {...props} />
  ) : (
    <El {...props}>{children}</El>
  );
};
